import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

export default function ServiceCard({ service, index = 0 }) {
  return (
    <motion.article
      className={`service-card ${service.accent}`}
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ delay: index * 0.05, duration: 0.45 }}
      whileHover={{ y: -7 }}
    >
      <div className="icon-box">
        <SafeIcon icon={FiIcons[service.icon]} />
      </div>
      <h3>{service.title}</h3>
      <p>{service.description}</p>
      <span className="card-arrow">
        <SafeIcon icon={FiIcons.FiArrowUpRight} />
      </span>
    </motion.article>
  );
}